const ZAPIER_URL = 'https://zapier.com/app/editor'
interface Props {
  onClose: () => void
}

export const ZapierRedirect = ({ onClose }: Props) => {
  window.open(ZAPIER_URL, '_blank')
  onClose()

  return null
}
